import classes from './constraintedit.module.scss';
import { TabPanel, TabView } from 'primereact/tabview';
import NDCHeader from '../NDCHeader';
import { InputSwitch } from 'primereact/inputswitch';
import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { useConstrainedForecastEdit } from './useConstrainedForecastEdit';
import ConceptDetailsSection from '../../../../../FDP/components/ConceptDetails';
import UnconstrainedForecastLoadingSkeleton from 'screens/FDPScreen/components/UnconstraintForecastScreen/components/UnconstraintForecastView/components/UnconstrainedForecastViewSkeleton';
import SummaryModal from '../SummaryModal';
import { ProgressSpinner } from 'primereact/progressspinner';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { constrainedForecastAllowedRoles } from 'data/fdp/fdpUserRolesValidations';
import ConceptDetailsSkeleton from 'screens/FDP/components/ConceptDetailsSkeleton';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import NotesSection from 'screens/FDPScreen/components/NotesSection';
import CopyIcon from 'assets/icons/copyIcon.svg';
import ResetIcon from 'assets/icons/revertIcon.svg';
import { Accordion, AccordionTab } from 'primereact/accordion';

const formatUnconstrainedForecast = (value: string) => {
  const numericValue = Number(value);
  return value !== '-' && !isNaN(numericValue) ? numericValue.toLocaleString('en-US') : value;
};

const ConstraintForecastEdit = () => {
  const {
    userModulesRoles,
    isConceptLoading,
    conceptDetails,
    contractDetails,
    directcurrentNDCIndex,
    indirectcurrentNDCIndex,
    directNDCheading,
    indirectNDCheading,
    forecastingMonthsEdit,
    isConstrainedForecastDataLoading,
    isConstrainedForecastNotesDataLoading,
    isInvoiceSalesLoading,
    checked: _checked,
    constrainedForecastEdit,
    showSummary,
    saveAllModal,
    singleSaveModal,
    savingSingle,
    savingAll,
    isDirectMode,
    copyRowInfo,
    // lastNDCInput,
    setChecked: _setChecked,
    handleCcancel,
    handleDirectNDCTabChange,
    handleIndirectNDCTabChange,
    getInvoiceSalesDetails,
    saveSingleConstrainedForecast,
    saveAllConstrainedForecast,
    saveForCategory,
    setShowSummary,
    setSingleSaveModal,
    setSaveAllModal,
    setIsDirectMode,
    handleNoteAdd,
    isConstrainedNoteSaving,
    ConstrainedForecastNotesData,
    getValueForNdc,
    checkIfValueTypeRadioButtonIsDisabled: _checkIfValueTypeRadioButtonIsDisabled,
    isValueTypeRadioButtonChecked,
    changeNdcValueType,
    getNdcData,
    checkIfPercentageEnabled,
    togglePercentageUsing,
    getAdjForecast,
    updateForecastAdjustment,
    savingForCategory,
    setSavingForCategory,
    isSavingSingle,
    isToggleVisible,
    handleCopyValues,
    handleResetValues,
    handleDeleteNote,
    handleEditNote,
    setNoteData,
    removeNoteData,
    isNoteEdited,
    isNoteDeleted,
    directInputFocus,
    indirectInputFocus,
    directFocused,
    indirectFocused,
    handleDirectKeyPress,
    handleIndirectKeyPress,
    handleDirectFocus,
    handleIndirectFocus,
    handleDirectBlur,
    handleIndirectBlur,
  } = useConstrainedForecastEdit();

  return (
    <div className={classes.viewContainer}>
      <div className={classes.conceptContainer}>
        <div className={classes.heading}>
          <h2>Constrained Forecast</h2>
        </div>
        <div
          style={{
            width: '100%',
            padding: '1rem',
          }}
        >
          {isConceptLoading ? (
            <ConceptDetailsSkeleton />
          ) : (
            <ConceptDetailsSection
              mode="edit"
              conceptDetails={conceptDetails}
              contractDetails={contractDetails}
            />
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: '1rem' }}>
        <div style={{ width: '90rem', marginLeft: '1rem', flexGrow: '1' }}>
          {isConceptLoading ||
          (isConstrainedForecastDataLoading &&
            (directNDCheading.length === 0 || indirectNDCheading.length === 0)) ? (
            <UnconstrainedForecastLoadingSkeleton />
          ) : (
            <div
              style={{
                width: '100%',
                border: '1px solid #E5E7EB',
                marginTop: '0.5rem',
                borderRadius: '8px',
                paddingTop: '1rem',
                paddingBottom: '1rem',
                height: '99%',
                backgroundColor: '#F7F3FE',
              }}
            >
              <div>
                {directNDCheading.length > 0 || indirectNDCheading.length > 0 ? (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      padding: '1rem',
                    }}
                  >
                    {/* Direct section start */}
                    {directNDCheading.length > 0 && (
                      <Accordion
                        className={classes.accordianComponent}
                        activeIndex={0}
                        onClick={() => setIsDirectMode(true)}
                      >
                        <AccordionTab header="Direct" className={classes.accordianTabComponent}>
                          <div className={classes.directtabContainer}>
                            {directNDCheading.length > 0 ? (
                              <TabView
                                scrollable
                                style={{ width: '100%' }}
                                tabIndex={directcurrentNDCIndex}
                                onTabChange={handleDirectNDCTabChange}
                              >
                                {(directNDCheading || []).map((ndc, index) => (
                                  <TabPanel
                                    key={index}
                                    header={
                                      <NDCHeader
                                        heading={ndc.ndc}
                                        isSelected={directcurrentNDCIndex === index}
                                        tabIndex={index}
                                      />
                                    }
                                  >
                                    <div className={classes.contentContainer}>
                                      <div className={classes.forecastContainer}>
                                        <h4>
                                          <span>
                                            Plan {forecastingMonthsEdit[0].label} -{' '}
                                            {forecastingMonthsEdit[14].label}{' '}
                                            <span style={{ color: 'green' }}>*</span>
                                          </span>
                                        </h4>

                                        <div className={classes.switcherContainer}>
                                          <span className={classes.btnLable}>Number</span>
                                          <InputSwitch
                                            className={classes.switchbtn}
                                            checked={checkIfPercentageEnabled()}
                                            onChange={togglePercentageUsing}
                                          />
                                          <span className={classes.btnLable}>Percent</span>
                                        </div>
                                        <div className={classes.switcherContainer}>
                                          {isToggleVisible() ? (
                                            <div></div>
                                          ) : (
                                            <div className={classes.switcherContainer}>
                                              <span className={classes.btnLable}>Old Values</span>
                                              <InputSwitch
                                                className={classes.switchbtn}
                                                checked={isValueTypeRadioButtonChecked('forecast')}
                                                onChange={() =>
                                                  isValueTypeRadioButtonChecked('forecast')
                                                    ? changeNdcValueType('old')
                                                    : changeNdcValueType('forecast')
                                                }
                                              />
                                              <span className={classes.btnLable}>
                                                Forecast Values
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <hr />
                                      <div
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'space-between',
                                          gap: '5rem',
                                          marginBottom: '1rem',
                                        }}
                                      >
                                        <div style={{ paddingLeft: '1rem' }}>
                                          <p>
                                            Pack Size:{' '}
                                            <span>
                                              {
                                                (directNDCheading || [])[directcurrentNDCIndex]
                                                  ?.packSize
                                              }
                                            </span>
                                          </p>
                                        </div>
                                        <div className={classes.saleDetails}>
                                          <div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingLeft: '3rem',
                                              }}
                                            >
                                              YTD:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  'ytd'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                              }}
                                            >
                                              3MA:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  '3ma'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                            <div className={classes.vertical}></div>
                                            <div
                                              style={{
                                                fontSize: '14px',
                                                fontWeight: '600',
                                                paddingRight: '3rem',
                                              }}
                                            >
                                              PM:{' '}
                                              {!isInvoiceSalesLoading ? (
                                                getInvoiceSalesDetails(
                                                  directNDCheading[directcurrentNDCIndex]?.ndc,
                                                  'pm'
                                                )
                                              ) : (
                                                <ProgressSpinner
                                                  style={{
                                                    width: '10px',
                                                    height: '10px',
                                                    padding: 0,
                                                    margin: 0,
                                                  }}
                                                  strokeWidth="8"
                                                  fill="var(--surface-ground)"
                                                  animationDuration="1s"
                                                />
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        <div style={{ paddingRight: '1rem' }}></div>
                                      </div>
                                      <div className={classes.forecastTable}>
                                        <table>
                                          <thead>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>
                                                Unconstrained Forecast
                                              </td>
                                            </th>
                                            <th>
                                              <td style={{ fontSize: '15px' }}>
                                                Constrained Forecast
                                              </td>
                                            </th>
                                            <th>
                                              <td></td>
                                            </th>
                                          </thead>
                                          <tbody>
                                            {(() => {
                                              const _ndcData = getNdcData();
                                              return _ndcData.forecast_data.map((data, idx) => {
                                              const derampTitle = data.is_deramped
                                                ? `NC De-ramp applied — contract term date: ${_ndcData.ContractEndDate ?? ''}`
                                                : undefined;
                                              return (
                                                <tr
                                                  key={idx}
                                                  title={derampTitle}
                                                  style={{
                                                    backgroundColor: `${
                                                      directFocused === idx ? '#f7f3fe' : ''
                                                    }`,
                                                  }}
                                                >
                                                  <td>{forecastingMonthsEdit[idx].label}</td>
                                                  <td>{formatUnconstrainedForecast(data.UnconstrainedForecast)}</td>
                                                  <td>
                                                    {checkIfPercentageEnabled() ? (
                                                      <>
                                                        <input
                                                          style={{
                                                            width: '15rem',
                                                            height: '2rem',
                                                            border: '1px solid #bababa',
                                                            fontSize: '0.9rem',
                                                            padding: '0.3rem 0',
                                                            paddingLeft: '0.5rem',
                                                            borderRadius: '0.3rem',
                                                            margin: 0,
                                                          }}
                                                          type="text"
                                                          pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                          value={getValueForNdc(idx)}
                                                          onChange={e =>
                                                            updateForecastAdjustment(
                                                              e.target.value,
                                                              idx
                                                            )
                                                          }
                                                          ref={(el: HTMLInputElement) =>
                                                            (directInputFocus.current[idx] = el)
                                                          }
                                                          onBlur={handleDirectBlur}
                                                          onFocus={() => {
                                                            handleDirectFocus(idx);
                                                          }}
                                                          onKeyDown={e =>
                                                            handleDirectKeyPress(e, idx)
                                                          }
                                                        />
                                                        {/* <ForecastInput
                                                            key={getValueForNdc(
                                                              idx
                                                            )}
                                                            forecastValue={getValueForNdc(
                                                              idx
                                                            )}
                                                            forecastMonthIndex={
                                                              idx
                                                            }
                                                            updateMethod={
                                                              updateForecastAdjustment
                                                            }
                                                            isPercentage={true}
                                                            onFocus={() =>
                                                              setFocusedRowItem(
                                                                forecastingMonthsEdit[
                                                                  idx
                                                                ].label,
                                                                data.UnconstrainedForecast
                                                              )
                                                            }
                                                            onFocusRemoved={() =>
                                                              removeFocusedRowItem(
                                                                forecastingMonthsEdit[
                                                                  idx
                                                                ].label,
                                                                data.UnconstrainedForecast
                                                              )
                                                            }
                                                          /> */}
                                                        <span
                                                          style={{
                                                            fontWeight: '600',
                                                          }}
                                                        >
                                                          {' '}
                                                          %
                                                        </span>
                                                      </>
                                                    ) : (
                                                      <input
                                                        style={{
                                                          width: '15rem',
                                                          height: '2rem',
                                                          border: '1px solid #bababa',
                                                          fontSize: '0.9rem',
                                                          padding: '0.3rem 0',
                                                          paddingLeft: '0.5rem',
                                                          borderRadius: '0.3rem',
                                                          margin: 0,
                                                        }}
                                                        type="text"
                                                        pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                        value={getValueForNdc(idx)}
                                                        onChange={e =>
                                                          updateForecastAdjustment(
                                                            e.target.value,
                                                            idx
                                                          )
                                                        }
                                                        ref={(el: HTMLInputElement) =>
                                                          (directInputFocus.current[idx] = el)
                                                        }
                                                        onBlur={handleDirectBlur}
                                                        onFocus={() => {
                                                          handleDirectFocus(idx);
                                                        }}
                                                        onKeyDown={e =>
                                                          handleDirectKeyPress(e, idx)
                                                        }
                                                      />
                                                      // <ForecastInput
                                                      //   isPercentage={false}
                                                      //   key={getValueForNdc(
                                                      //     idx
                                                      //   )}
                                                      //   forecastValue={getValueForNdc(
                                                      //     idx
                                                      //   )}
                                                      //   forecastMonthIndex={
                                                      //     idx
                                                      //   }
                                                      //   updateMethod={
                                                      //     updateForecastAdjustment
                                                      //   }
                                                      //   onFocus={() =>
                                                      //     setFocusedRowItem(
                                                      //       forecastingMonthsEdit[
                                                      //         idx
                                                      //       ].label,
                                                      //       data.UnconstrainedForecast
                                                      //     )
                                                      //   }
                                                      //   onFocusRemoved={() =>
                                                      //     removeFocusedRowItem(
                                                      //       forecastingMonthsEdit[
                                                      //         idx
                                                      //       ].label,
                                                      //       data.UnconstrainedForecast
                                                      //     )
                                                      //   }
                                                      // />
                                                    )}
                                                  </td>
                                                  <td>
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '0.5rem',
                                                        width: '5rem',
                                                      }}
                                                    >
                                                      <Button
                                                        style={{
                                                          height: '28px',
                                                          width: '40px',
                                                        }}
                                                        icon={
                                                          <img
                                                            src={CopyIcon}
                                                            style={{
                                                              height: '20px',
                                                              width: '20px',
                                                              cursor: 'pointer',
                                                              opacity:
                                                                getValueForNdc(idx) !== '-'
                                                                  ? '0.8'
                                                                  : '0.4',
                                                            }}
                                                          />
                                                        }
                                                        disabled={
                                                          getValueForNdc(idx) == '-' ? true : false
                                                        }
                                                        onClick={() => handleCopyValues(idx)}
                                                        rounded
                                                        text
                                                        aria-label="Filter"
                                                      />
                                                      {copyRowInfo.has(
                                                        directNDCheading[directcurrentNDCIndex]
                                                          .ndc + idx
                                                      ) ? (
                                                        <Button
                                                          style={{
                                                            height: '28px',
                                                            width: '40px',
                                                          }}
                                                          icon={
                                                            <img
                                                              src={ResetIcon}
                                                              style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                cursor: 'pointer',
                                                                opacity:
                                                                  getValueForNdc(idx) !== '-'
                                                                    ? '0.8'
                                                                    : '0.4',
                                                              }}
                                                            />
                                                          }
                                                          disabled={
                                                            getValueForNdc(idx) == '-'
                                                              ? true
                                                              : false
                                                          }
                                                          onClick={() => handleResetValues(idx)}
                                                          rounded
                                                          text
                                                          aria-label="Filter"
                                                        />
                                                      ) : (
                                                        <div></div>
                                                      )}
                                                    </div>
                                                  </td>
                                                </tr>
                                              );
                                            });
                                            })()}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </TabPanel>
                                ))}
                              </TabView>
                            ) : (
                              <div
                                style={{
                                  height: '42rem',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  fontSize: '2rem',
                                  width: '100%',
                                  flexGrow: 1,
                                }}
                              >
                                {`No Baseline data available for ${
                                  isDirectMode ? 'Direct' : 'Indirect'
                                } selling category.`}
                              </div>
                            )}
                          </div>

                          <div className={classes.categoryButtonGroup}>
                            <Button
                              className={classes.saveBtnStyle}
                              onClick={() => setSingleSaveModal(prev => !prev)}
                              disabled={
                                (constrainedForecastEdit.length === 0 &&
                                  directNDCheading.length === 0) ||
                                !checkIfFunctionalityEnabled(
                                  constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
                                  userModulesRoles.fdp,
                                  userModulesRoles
                                ) ||
                                directNDCheading.length === 0
                              }
                              tooltip={`Will save the Constrained Forecast for ${directNDCheading[indirectcurrentNDCIndex]?.ndc}`}
                              tooltipOptions={{ position: 'top' }}
                            >
                              Save
                            </Button>
                            <Button
                              className={classes.finishBtnStyle}
                              disabled={
                                (constrainedForecastEdit.length === 0 &&
                                  directNDCheading.length === 0) ||
                                !checkIfFunctionalityEnabled(
                                  constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
                                  userModulesRoles.fdp,
                                  userModulesRoles
                                ) ||
                                directNDCheading.length === 0
                              }
                              tooltip={`Will save Constrained Forecast for ${
                                isDirectMode ? 'Direct' : 'Indirect'
                              } NDCs`}
                              tooltipOptions={{ position: 'top' }}
                              onClick={() => setSavingForCategory(prev => !prev)}
                            >
                              Finish
                            </Button>
                          </div>
                        </AccordionTab>
                      </Accordion>
                    )}
                    {/* Direct section start */}

                    {/* Indirect section start */}
                    {indirectNDCheading.length > 0 && (
                      <Accordion
                        className={classes.accordianComponent}
                        onClick={() => setIsDirectMode(false)}
                        activeIndex={directNDCheading.length === 0 ? 0 : null}
                      >
                        <AccordionTab header="Indirect" className={classes.accordianTabComponent}>
                          <div className={classes.directtabContainer}>
                            {/* {indirectNDCheading.length > 0 ? ( */}
                            <TabView
                              scrollable
                              style={{ width: '100%' }}
                              tabIndex={indirectcurrentNDCIndex}
                              onTabChange={handleIndirectNDCTabChange}
                            >
                              {indirectNDCheading.map((ndc, index) => (
                                <TabPanel
                                  key={index}
                                  header={
                                    <NDCHeader
                                      heading={ndc.ndc}
                                      isSelected={indirectcurrentNDCIndex === index}
                                      tabIndex={index}
                                    />
                                  }
                                >
                                  <div className={classes.contentContainer}>
                                    <div className={classes.forecastContainer}>
                                      <h4>
                                        <span>
                                          Plan {forecastingMonthsEdit[0].label} -{' '}
                                          {forecastingMonthsEdit[14].label}{' '}
                                          <span style={{ color: 'green' }}>*</span>
                                        </span>
                                      </h4>

                                      <div className={classes.switcherContainer}>
                                        <span className={classes.btnLable}>Number</span>
                                        <InputSwitch
                                          className={classes.switchbtn}
                                          checked={checkIfPercentageEnabled()}
                                          onChange={togglePercentageUsing}
                                        />
                                        <span className={classes.btnLable}>Percent</span>
                                      </div>
                                      <div className={classes.switcherContainer}>
                                        {isToggleVisible() ? (
                                          <div></div>
                                        ) : (
                                          <div className={classes.switcherContainer}>
                                            <span className={classes.btnLable}>Old Values</span>
                                            <InputSwitch
                                              className={classes.switchbtn}
                                              checked={isValueTypeRadioButtonChecked('forecast')}
                                              onChange={() =>
                                                isValueTypeRadioButtonChecked('forecast')
                                                  ? changeNdcValueType('old')
                                                  : changeNdcValueType('forecast')
                                              }
                                            />
                                            <span className={classes.btnLable}>
                                              Forecast Values
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <hr />
                                    <div
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: '5rem',
                                        marginBottom: '1rem',
                                      }}
                                    >
                                      <div style={{ paddingLeft: '1rem' }}>
                                        <p>
                                          Pack Size:{' '}
                                          <span>
                                            {
                                              (indirectNDCheading || [])[indirectcurrentNDCIndex]
                                                ?.packSize
                                            }
                                          </span>
                                        </p>
                                      </div>
                                      <div className={classes.saleDetails}>
                                        <div>
                                          <div
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '600',
                                              paddingLeft: '3rem',
                                            }}
                                          >
                                            YTD:{' '}
                                            {!isInvoiceSalesLoading ? (
                                              getInvoiceSalesDetails(
                                                indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                'ytd'
                                              )
                                            ) : (
                                              <ProgressSpinner
                                                style={{
                                                  width: '10px',
                                                  height: '10px',
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                                strokeWidth="8"
                                                fill="var(--surface-ground)"
                                                animationDuration="1s"
                                              />
                                            )}
                                          </div>
                                          <div className={classes.vertical}></div>
                                          <div
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '600',
                                            }}
                                          >
                                            3MA:{' '}
                                            {!isInvoiceSalesLoading ? (
                                              getInvoiceSalesDetails(
                                                indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                '3ma'
                                              )
                                            ) : (
                                              <ProgressSpinner
                                                style={{
                                                  width: '10px',
                                                  height: '10px',
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                                strokeWidth="8"
                                                fill="var(--surface-ground)"
                                                animationDuration="1s"
                                              />
                                            )}
                                          </div>
                                          <div className={classes.vertical}></div>
                                          <div
                                            style={{
                                              fontSize: '14px',
                                              fontWeight: '600',
                                              paddingRight: '3rem',
                                            }}
                                          >
                                            PM:{' '}
                                            {!isInvoiceSalesLoading ? (
                                              getInvoiceSalesDetails(
                                                indirectNDCheading[indirectcurrentNDCIndex]?.ndc,
                                                'pm'
                                              )
                                            ) : (
                                              <ProgressSpinner
                                                style={{
                                                  width: '10px',
                                                  height: '10px',
                                                  padding: 0,
                                                  margin: 0,
                                                }}
                                                strokeWidth="8"
                                                fill="var(--surface-ground)"
                                                animationDuration="1s"
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div
                                          style={{ paddingRight: "1rem" }}
                                        ></div> */}
                                    </div>
                                    <div className={classes.forecastTable}>
                                      <table>
                                        <thead>
                                          <th>
                                            <td style={{ fontSize: '15px' }}>Forecast Period</td>
                                          </th>
                                          <th>
                                            <td style={{ fontSize: '15px' }}>
                                              Unconstrained Forecast
                                            </td>
                                          </th>
                                          <th>
                                            <td style={{ fontSize: '15px' }}>
                                              Constrained Forecast
                                            </td>
                                          </th>
                                          <th>
                                            <td></td>
                                          </th>
                                        </thead>
                                        <tbody>
                                          {(() => {
                                            const _ndcData = getNdcData();
                                            return _ndcData.forecast_data.map((data, idx) => {
                                            const derampTitle = data.is_deramped
                                              ? `NC De-ramp applied — contract term date: ${_ndcData.ContractEndDate ?? ''}`
                                              : undefined;
                                            return (
                                              <tr
                                                key={idx}
                                                title={derampTitle}
                                                style={{
                                                  backgroundColor: `${
                                                    indirectFocused === idx ? '#f7f3fe' : ''
                                                  }`,
                                                }}
                                              >
                                                <td>{forecastingMonthsEdit[idx].label}</td>
                                                <td>{formatUnconstrainedForecast(data.UnconstrainedForecast)}</td>
                                                <td>
                                                  {checkIfPercentageEnabled() ? (
                                                    <>
                                                      <input
                                                        style={{
                                                          width: '15rem',
                                                          height: '2rem',
                                                          border: '1px solid #bababa',
                                                          fontSize: '0.9rem',
                                                          padding: '0.3rem 0',
                                                          paddingLeft: '0.5rem',
                                                          borderRadius: '0.3rem',
                                                          margin: 0,
                                                        }}
                                                        type="text"
                                                        pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                        value={getValueForNdc(idx)}
                                                        onChange={e =>
                                                          updateForecastAdjustment(
                                                            e.target.value,
                                                            idx
                                                          )
                                                        }
                                                        ref={(el: HTMLInputElement) =>
                                                          (indirectInputFocus.current[idx] = el)
                                                        }
                                                        onBlur={handleIndirectBlur}
                                                        onFocus={() => handleIndirectFocus(idx)}
                                                        onKeyDown={e =>
                                                          handleIndirectKeyPress(e, idx)
                                                        }
                                                      />
                                                      {/* <ForecastInput
                                                          key={getValueForNdc(
                                                            idx
                                                          )}
                                                          forecastValue={getValueForNdc(
                                                            idx
                                                          )}
                                                          forecastMonthIndex={
                                                            idx
                                                          }
                                                          updateMethod={
                                                            updateForecastAdjustment
                                                          }
                                                          isPercentage={true}
                                                          onFocus={() =>
                                                            setFocusedRowItem(
                                                              forecastingMonthsEdit[
                                                                idx
                                                              ].label,
                                                              data.UnconstrainedForecast
                                                            )
                                                          }
                                                          onFocusRemoved={() =>
                                                            removeFocusedRowItem(
                                                              forecastingMonthsEdit[
                                                                idx
                                                              ].label,
                                                              data.UnconstrainedForecast
                                                            )
                                                          }
                                                        /> */}
                                                      <span
                                                        style={{
                                                          fontWeight: '600',
                                                        }}
                                                      >
                                                        {' '}
                                                        %
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <input
                                                      style={{
                                                        width: '15rem',
                                                        height: '2rem',
                                                        border: '1px solid #bababa',
                                                        fontSize: '0.9rem',
                                                        padding: '0.3rem 0',
                                                        paddingLeft: '0.5rem',
                                                        borderRadius: '0.3rem',
                                                        margin: 0,
                                                      }}
                                                      type="text"
                                                      pattern="[+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d+)?"
                                                      value={getValueForNdc(idx)}
                                                      onChange={e =>
                                                        updateForecastAdjustment(
                                                          e.target.value,
                                                          idx
                                                        )
                                                      }
                                                      ref={(el: HTMLInputElement) =>
                                                        (indirectInputFocus.current[idx] = el)
                                                      }
                                                      onBlur={handleIndirectBlur}
                                                      onFocus={() => handleIndirectFocus(idx)}
                                                      onKeyDown={e =>
                                                        handleIndirectKeyPress(e, idx)
                                                      }
                                                    />
                                                    // <ForecastInput
                                                    //   isPercentage={false}
                                                    //   key={getValueForNdc(
                                                    //     idx
                                                    //   )}
                                                    //   forecastValue={getValueForNdc(
                                                    //     idx
                                                    //   )}
                                                    //   forecastMonthIndex={idx}
                                                    //   updateMethod={
                                                    //     updateForecastAdjustment
                                                    //   }
                                                    //   onFocus={() =>
                                                    //     setFocusedRowItem(
                                                    //       forecastingMonthsEdit[
                                                    //         idx
                                                    //       ].label,
                                                    //       data.UnconstrainedForecast
                                                    //     )
                                                    //   }
                                                    //   onFocusRemoved={() =>
                                                    //     removeFocusedRowItem(
                                                    //       forecastingMonthsEdit[
                                                    //         idx
                                                    //       ].label,
                                                    //       data.UnconstrainedForecast
                                                    //     )
                                                    //   }
                                                    // />
                                                  )}
                                                </td>
                                                <td>
                                                  <div
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center',
                                                      gap: '0.5rem',
                                                      width: '5rem',
                                                    }}
                                                  >
                                                    <Button
                                                      style={{
                                                        height: '28px',
                                                        width: '40px',
                                                      }}
                                                      icon={
                                                        <img
                                                          src={CopyIcon}
                                                          style={{
                                                            height: '20px',
                                                            width: '20px',
                                                            cursor: 'pointer',
                                                            opacity:
                                                              getValueForNdc(idx) !== '-'
                                                                ? '0.8'
                                                                : '0.4',
                                                          }}
                                                        />
                                                      }
                                                      disabled={
                                                        getValueForNdc(idx) == '-' ? true : false
                                                      }
                                                      onClick={() => handleCopyValues(idx)}
                                                      rounded
                                                      text
                                                      aria-label="Filter"
                                                    />
                                                    {copyRowInfo.has(
                                                      indirectNDCheading[indirectcurrentNDCIndex]
                                                        .ndc + idx
                                                    ) ? (
                                                      <Button
                                                        style={{
                                                          height: '28px',
                                                          width: '40px',
                                                        }}
                                                        icon={
                                                          <img
                                                            src={ResetIcon}
                                                            style={{
                                                              height: '20px',
                                                              width: '20px',
                                                              cursor: 'pointer',
                                                              opacity:
                                                                getValueForNdc(idx) !== '-'
                                                                  ? '0.8'
                                                                  : '0.4',
                                                            }}
                                                          />
                                                        }
                                                        disabled={
                                                          getValueForNdc(idx) == '-' ? true : false
                                                        }
                                                        onClick={() => handleResetValues(idx)}
                                                        rounded
                                                        text
                                                        aria-label="Filter"
                                                      />
                                                    ) : (
                                                      <div></div>
                                                    )}
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          });
                                          })()}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </TabPanel>
                              ))}
                            </TabView>
                          </div>

                          <div className={classes.categoryButtonGroup}>
                            <Button
                              className={classes.saveBtnStyle}
                              onClick={() => setSingleSaveModal(prev => !prev)}
                              disabled={
                                (constrainedForecastEdit.length === 0 &&
                                  indirectNDCheading.length === 0) ||
                                !checkIfFunctionalityEnabled(
                                  constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
                                  userModulesRoles.fdp,
                                  userModulesRoles
                                ) ||
                                indirectNDCheading.length === 0
                              }
                              tooltip={`Will save the Constrained Forecast for ${indirectNDCheading[indirectcurrentNDCIndex]?.ndc}`}
                              tooltipOptions={{ position: 'top' }}
                            >
                              Save
                            </Button>
                            <Button
                              className={classes.finishBtnStyle}
                              disabled={
                                (constrainedForecastEdit.length === 0 &&
                                  indirectNDCheading.length === 0) ||
                                !checkIfFunctionalityEnabled(
                                  constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
                                  userModulesRoles.fdp,
                                  userModulesRoles
                                ) ||
                                indirectNDCheading.length === 0
                              }
                              tooltip={`Will save Constrained Forecast for ${
                                isDirectMode ? 'Direct' : 'Indirect'
                              } NDCs`}
                              tooltipOptions={{ position: 'top' }}
                              onClick={() => setSavingForCategory(prev => !prev)}
                            >
                              Finish
                            </Button>
                          </div>
                        </AccordionTab>
                      </Accordion>
                    )}
                    {/* Indirect section start */}
                  </div>
                ) : (
                  <div
                    style={{
                      height: '42rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '2rem',
                    }}
                  >
                    No Unconstrained Forecast data found!!
                  </div>
                )}
                <div className={classes.bottomBtngroup}>
                  <Button
                    style={{
                      backgroundColor: '#4D2E6D',
                      color: '#FFFFFF',
                      fontWeight: 600,
                      border: 'none',
                    }}
                    onClick={() => setShowSummary(true)}
                    disabled={
                      (constrainedForecastEdit.length === 0 &&
                        (directNDCheading.length === 0 || indirectNDCheading.length === 0)) ||
                      (isDirectMode
                        ? directNDCheading.length === 0
                        : indirectNDCheading.length === 0)
                    }
                  >
                    Show Summary
                  </Button>
                  <div>
                    <Button
                      style={{
                        backgroundColor: '#D8000C',
                        color: '#FFFFFF',
                        fontWeight: 600,
                        border: 'none',
                      }}
                      onClick={handleCcancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{
                        backgroundColor: '#4D2E6D',
                        color: '#FFFFFF',
                        fontWeight: 600,
                        border: 'none',
                      }}
                      onClick={() => setSaveAllModal(prev => !prev)}
                      disabled={
                        (constrainedForecastEdit.length === 0 &&
                          (directNDCheading.length === 0 || indirectNDCheading.length === 0)) ||
                        !checkIfFunctionalityEnabled(
                          constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
                          userModulesRoles.fdp,
                          userModulesRoles
                        ) ||
                        (isDirectMode
                          ? directNDCheading.length === 0
                          : indirectNDCheading.length === 0)
                      }
                      tooltip="Will save Constrained forecast for all Direct and Indirect NDCs"
                      tooltipOptions={{ position: 'top' }}
                    >
                      Finish for All
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <NotesSection
          mode="edit"
          isNotesDataLoading={
            isConstrainedForecastNotesDataLoading ||
            isConstrainedForecastDataLoading ||
            isConceptLoading
          }
          isNoteAddLoading={isConstrainedNoteSaving}
          notesData={ConstrainedForecastNotesData}
          setNoteData={setNoteData}
          removeNoteData={removeNoteData}
          handleAddNote={handleNoteAdd}
          handleEditNote={handleEditNote}
          editLoading={isNoteEdited}
          handleDeleteNote={handleDeleteNote}
          deleteLoading={isNoteDeleted}
          isAddNewButtonDisabled={
            !checkIfFunctionalityEnabled(
              constrainedForecastAllowedRoles.bulkUpdateConstrainedForecast,
              userModulesRoles.fdp,
              userModulesRoles
            ) || (isDirectMode ? directNDCheading.length === 0 : indirectNDCheading.length === 0)
          }
        />
      </div>

      {/* summary modal component */}
      <SummaryModal
        visibility={showSummary}
        toggleVisibility={() => setShowSummary(prev => !prev)}
        forecastingMonths={forecastingMonthsEdit}
        getConstrainedForecast={getAdjForecast}
        directNDCheading={directNDCheading}
        indirectNDCheading={indirectNDCheading}
      />

      {/* single save modal component */}
      <ConfirmationModal
        visibility={singleSaveModal}
        modalHeading="Confirmaion"
        modalContent={`Are you sure want to create Constrained Forecast for NDC -
          ${
            isDirectMode
              ? directNDCheading[directcurrentNDCIndex]?.ndc
              : indirectNDCheading[indirectcurrentNDCIndex]?.ndc
          }
          ?`}
        confirmLabel="Create"
        loading={savingSingle}
        handleCancel={() => setSingleSaveModal(prev => !prev)}
        handleConfirm={saveSingleConstrainedForecast}
      />

      {/* Finish modal component */}
      <ConfirmationModal
        visibility={saveAllModal || savingForCategory}
        modalHeading="Confirmation"
        modalContent={`Are you sure want to create Unconstrained Forecast for all Pack
          Sizes ${
            savingForCategory ? `for ${isDirectMode ? 'Direct' : 'Indirect'} category` : ''
          } in ${conceptDetails?.concept}?`}
        confirmLabel="Create"
        loading={savingAll || isSavingSingle}
        handleCancel={() => {
          if (saveAllModal) {
            setSaveAllModal(prev => !prev);
          } else if (savingForCategory) {
            setSavingForCategory(prev => !prev);
          }
        }}
        handleConfirm={() => (savingForCategory ? saveForCategory() : saveAllConstrainedForecast())}
      />
    </div>
  );
};

export default observer(ConstraintForecastEdit);
